import { User } from "./User";

export const NEWUSER: User = {
  accountId: 0,
  createdBy: 0,
  createdOn: "",
  email: "",
  enabled: true,
  isAdministrator: false,
  modifiedBy: 0,
  modifiedOn: "",
  name: "",
  password: "",
  phoneNumber: "",
  roleId: 0,
  roleType: "",
  id: 0
};